import GridKeikkaEditor_Teksti_Row from "../../teksti/GridKeikkaEditor_Teksti_Row";
import PropTypes from "prop-types";

// eslint-disable-next-line no-unused-vars
export default function GridKeikkaEditor_Teksti_Asiakas({ subText, keikkaState }) {
  return <GridKeikkaEditor_Teksti_Row title="Asiakas" sub={keikkaState?.asiakasNimi} gray />;
}

GridKeikkaEditor_Teksti_Asiakas.propTypes = {
  subText: PropTypes.func,
  keikkaState: PropTypes.object,
};
